/**
 * Navigation Policy
 *
 * Executes React Router navigation when pendingNavigation is set.
 * Also records navigation in history for audit trail.
 */

import { Policy } from '@commandDrivenStateEngine/core/policies';
import { NavigationState } from '../state';
import { NavigationCommand } from '../commands';
import { NavigateFunction } from 'react-router';

/**
 * Creates the navigation policy with React Router's navigate function.
 *
 * @param navigate - React Router's navigate function from useNavigate()
 */
export const createNavigationPolicy = (
  navigate: NavigateFunction
): Policy<NavigationState, NavigationCommand> => ({
  name: 'navigationPolicy',

  shouldReact: ( prev, next ) => {
    // Trigger when pendingNavigation changes from null to a value
    return prev.pendingNavigation === null && next.pendingNavigation !== null;
  },

  onStateChange: ({ next, ctx }) => {
    if ( !next.pendingNavigation ) return;

    const { path, params, source } = next.pendingNavigation;

    // Execute React Router navigation
    navigate( path, { state: params });

    // Record in history
    ctx.dispatch(
      {
        type: 'navigation/history/record',
        payload: { path, params: params || {}}
      },
      { source }
    );

    // Clear pending navigation
    ctx.dispatch(
      { type: 'navigation/request/clear', payload: {}},
      { source: 'api' }
    );
  }
});
